var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg18PxGear2 = function Svg18PxGear2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25 4.237 9 9M6.25 13.764 9 9M14.5 9H9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 1.75V3.5M2.721 5.375l1.516.875M1.75 9H3.5M16.25 9H14.5M2.721 12.625l1.516-.875M9 16.25V14.5M12.625 15.279l-.875-1.516M5.375 15.279l.875-1.516M15.279 12.625l-1.516-.875M15.279 5.375l-1.516.875M12.625 2.721l-.875 1.516M5.375 2.721l.875 1.516"
  }))));
};
export default Svg18PxGear2;